module.exports = __webpack_public_path__ + "static/media/avatar-29.b8b66b5b.svg";